import { render, staticRenderFns } from "./ComponenteChat.vue?vue&type=template&id=c9527868&"
import script from "./ComponenteChat.vue?vue&type=script&lang=ts&"
export * from "./ComponenteChat.vue?vue&type=script&lang=ts&"
import style0 from "./ComponenteChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c9527868', component.options)
    } else {
      api.reload('c9527868', component.options)
    }
    module.hot.accept("./ComponenteChat.vue?vue&type=template&id=c9527868&", function () {
      api.rerender('c9527868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Chat/ComponenteChat.vue"
export default component.exports